// extracted by mini-css-extract-plugin
export default {"link":"Link_link__8d64d","link--small":"Link_link--small__ea82b","link--medium":"Link_link--medium__fd5eb","link--large":"Link_link--large__fee8a"};